// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.UserLookUp.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * UserLookUp component
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from 'share/enhancers/Izenda.Connect';
import localizer from 'share/localization/Izenda.Localizer';
import Validator from 'share/components/hoc/Izenda.Validator';
import Select from 'share/components/controls/multiSelectBox/Izenda.Select';
import action from './Izenda.UserLookUpAction';

const ValidatorSelect = Validator()(Select);

const UserLookUp = (props: any) => (
  <div className="izenda-Recipient-Container">
    <ValidatorSelect
      textboxMode
      multi
      hiddenMenu
      searchable={false}
      clearable={false}
      disabled={props.disabled || props.readOnly}
      options={props.data}
      valueKey={props.valueField}
      labelKey={props.textField}
      value={props.value}
      validations={props.validations}
      field={props.field}
      group={props.group}
      onChange={props.onChange}
    />
    {props.usingPopup && (
      <a>
        <span
          onClick={!props.readOnly && props.openPopupAddUserPopup}
          className="icon-plus"
          title={localizer.getText('USER_LABEL_SELECT_USER')}
        />
      </a>
    )}
  </div>
);

UserLookUp.propTypes = {
  disabled: PropTypes.bool,
  usingPopup: PropTypes.bool,
  data: PropTypes.array,
  valueField: PropTypes.string,
  textField: PropTypes.string,
  field: PropTypes.string,
  onChange: PropTypes.func,
  validations: PropTypes.object,
  userModeType: PropTypes.number
};

export default connect(action)(UserLookUp);



// WEBPACK FOOTER //
// ./ui/modules/User/Izenda.UserLookUp.jsx